export default {
	cancel: 'Cancel',
	chat_widget_context_label: 'Context',
	chat_widget_role_assistant: 'Assistant',
	chat_widget_role_user: 'You',
	common_actions: 'Actions',
	common_add: 'Link',
	common_back: 'Back',
	common_cancel: 'Cancel',
	common_claim: 'Claim',
	common_clear: 'Clear search',
	common_close: 'Close',
	common_copy_url_to_clipboard: 'Copy URL to clipboard',
	common_copy_url_to_clipboard_notification: 'The URL was copied to the clipboard',
	common_custom_color_delete_color_scheme_dialog_confirm_message: 'Do you really want to delete the theme?',
	common_custom_color_delete_color_scheme_dialog_confirm_title: 'Confirm deletion',
	common_custom_color_scheme_cancel: 'Cancel',
	common_custom_color_scheme_delete: 'Delete',
	common_custom_color_scheme_save: 'Save',
	common_custom_color_scheme_theme_edit_header: 'Edit theme',
	common_custom_color_scheme_theme_name: 'Theme name',
	common_custom_color_scheme_theme_name_required: 'The Theme name field is required',
	common_date: 'Date',
	common_delete: 'Delete',
	common_detail_unavailable_title: 'Entry not available',
	common_discard: 'Discard',
	common_do_not_published: 'Hide',
	common_edit: 'Edit',
	common_kanban_activity_count: '{count} activities',
	common_kanban_behavior: 'Behavior',
	common_kanban_board_selection: 'Board selection',
	common_kanban_empty_board: 'No columns available',
	common_kanban_empty_board_hint: 'Select a query and field from the toolbar',
	common_kanban_empty_lane: 'No entries',
	common_kanban_favorites: 'Favorites',
	common_kanban_field_height: 'Field height',
	common_kanban_lane_tooltip: 'Columns by',
	common_kanban_lanes: 'Columns',
	common_kanban_loading: 'Loading board…',
	common_kanban_multi_fields: 'Multi-choice fields',
	common_kanban_open_list: 'Open record list',
	common_kanban_opt_fields: 'Value fields',
	common_kanban_padding: 'Padding',
	common_kanban_query_tooltip: 'Selected query',
	common_kanban_remember_last_board: 'Remember last active board',
	common_kanban_select_lane: 'Select field',
	common_kanban_select_query: 'Select query',
	common_kanban_send_to_bottom: 'Send to bottom',
	common_kanban_send_to_top: 'Send to top',
	common_kanban_settings: 'Settings',
	common_kanban_show_suppressed: 'Show hidden columns',
	common_kanban_single_fields: 'Single-choice fields',
	common_kanban_toggle_favorite: 'Toggle favorite',
	common_loading: 'Loading…',
	common_maximize: 'Maximize',
	common_minimize: 'Minimize',
	common_module_activity: 'Memo',
	common_module_appointment: 'Appointment',
	common_module_dataset: 'Dataset',
	common_module_document: 'Document',
	common_module_mail: 'Mail',
	common_module_message: 'Message',
	common_module_note: 'Note',
	common_module_phonecall: 'Phone call',
	common_module_task: 'Task',
	common_not_published: 'Hidden',
	common_ok: 'OK',
	common_open_in_fullscreen: 'Fullscreen',
	common_open_in_new_browser_tab: 'Open in new browser tab',
	common_picker_done: 'Done',
	common_picker_search_clear: 'Clear search',
	common_pin: 'Pin',
	common_plan: 'Schedule task',
	common_publish: 'Publish',
	common_published: 'Published',
	common_refresh: 'Refresh',
	common_restore: 'Restore',
	common_save: 'Save',
	common_search: 'Search',
	common_share: 'Share',
	common_spam: 'Mark as spam',
	common_time: 'Time',
	date_time_picker_open_date_picker_aria_label: 'Open date picker',
	date_time_picker_open_time_picker_aria_label: 'Open time picker',
	deactivate_favorites_dialog_confirm: 'Deactivate shortcuts',
	deactivate_favorites_dialog_message:
		'You have active shortcuts. Do you want to deactivate them and close the search field?',
	deactivate_favorites_dialog_subtitle: 'The shortcuts will not be deleted and can be reactivated later.',
	deactivate_favorites_dialog_title: 'Deactivate shortcuts?',
	ok: 'OK',
	save: 'Save',
};
